"use client";

import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import PersistentHero from "./components/persistent/PersistentHero";
import GlassFeed from "./components/persistent/GlassFeed";
import NavigationDock from "./components/persistent/NavigationDock";
import HikariNarrative from "./components/content/HikariNarrative";

// Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

export default function Home() {
  const [activeTab, setActiveTab] = React.useState("Hikari");
  const heroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!heroRef.current) return;

    const ctx = gsap.context(() => {
      gsap.to(heroRef.current, {
        scale: 0.95,
        filter: "brightness(0.95) blur(10px)",
        ease: "none",
        scrollTrigger: {
          trigger: document.body,
          start: "top top",
          end: "100vh top",
          scrub: 1,
        }
      });
    }, heroRef);

    return () => ctx.revert();
  }, []);

  // Handle scrolling for "Collab" tab
  useEffect(() => {
    if (activeTab === "Collab") {
      // Simple timeout to allow mount, then scroll to bottom or specific section
      // Since we don't have refs inside HikariNarrative easily accessible here without more complexity,
      // scrolling to bottom is a safe bet for "Contact/Collab" usually at the end.
      setTimeout(() => {
        window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
      }, 100);
    } else if (activeTab === "Hikari") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [activeTab]);

  return (
    <main className="relative w-full min-h-screen bg-[#EAE8E4]">
      {/* Fixed Background Layer (The Canvas) - Only show on Journal to allow Hikari narrative its own logic? 
          Actually, let's keep it as the persistent background for continuity, 
          but if Hikari view is active, maybe we want to hide it or overlay on top.
          The prompt implies Hikari view is a "page".
          Let's make Hikari view a full overlay on top of everything else if active.
      */}
      <div ref={heroRef} className="fixed inset-0 z-0 origin-center will-change-transform">
        <PersistentHero />
      </div>

      {/* Conditionally Render Views */}
      {(activeTab === "Hikari" || activeTab === "Collab") && (
        <div className="relative z-10">
          <HikariNarrative />
        </div>
      )}

      {activeTab === "Journal" && (
        <div className="relative z-10 will-change-transform">
          <GlassFeed />
        </div>
      )}

      {/* activeTab === "Collab" -> For now just scroll to bottom of Hikari or show Hikari view scrolled? 
          The prompt says nav labels: HIKARI, JOURNAL, COLLAB. 
          The HikariNarrative has a "Services & Collaboration" section. 
          Maybe clicking Collab should switch to Hikari view and scroll to that section.
          Let's handle that effect.
      */}

      {/* Floating Navigation */}
      <NavigationDock activeTab={activeTab === "Collab" ? "Hikari" : activeTab} setActiveTab={setActiveTab} />
    </main>
  );
}
